import {AfterViewInit, Component, ElementRef, OnInit, Renderer} from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {AlertService, EventManager} from 'ng-jhipster';

import { Account, Principal } from '../shared';
import {LoginService} from '../shared/login/login.service';
import {Router} from '@angular/router';
import {StateStorageService} from '../shared/auth/state-storage.service';
import {HomeService} from './home.service';
import {CampaignService} from '../entities/campaign/campaign.service';
import {QuestionVM} from './question.model';
import {UtilsService} from '../shared/utils/utils.service';
import {SaisineService} from '../entities/saisine';
import {Observable} from 'rxjs/Observable';
import { Region } from '../admin/user-management/region.model';
import { RegionService } from '../admin/user-management/region.service';

@Component({
    selector: 'jhi-home',
    templateUrl: './home.component.html',
    styleUrls: [
        './home.scss'
    ]

})
export class HomeComponent implements OnInit, AfterViewInit {
    account: Account;
    modalRef: NgbModalRef;

    questions: QuestionVM[];
    messages: any;
    authenticationError: boolean;

    email: string;
    password: string;
    rememberMe: boolean;

    regions: Region[];
    selectedRegionLabel: String = '';

    constructor(
        public alertService: AlertService,
        public saisineService: SaisineService,
        public homeService: HomeService,
        private principal: Principal,
        private eventManager: EventManager,
        private loginService: LoginService,
        private stateStorageService: StateStorageService,
        private router: Router,
        private utilsService: UtilsService,
        public campaignService: CampaignService,
        private regionService: RegionService,
        private elementRef: ElementRef,
        private renderer: Renderer
    ) {
        this.questions = [];
    }

    ngOnInit() {
        this.rememberMe = false;

        Observable.combineLatest(this.homeService.getQuestions(), this.homeService.getMessages(), this.regionService.getRegions({'campaign': this.campaignService.getCurrentCampaignYear()})).subscribe(([questions, messages, regions]) => {
            this.regions = regions.filter(_ =>  _.contactEmail).sort((r1, r2) => r1.academicRegionLabel.localeCompare(r2.academicRegionLabel));
            questions.forEach(question => {
                // remplacement des balises angular en données via le replace car affichées en innerHTML
                question.questionLabel = question.questionLabel.replace(/{{campaign}}/g, this.campaignService.getCurrentCampaignYear());
                question.questionLabel = question.questionLabel.replace(/{{campaignstart}}/g, this.campaignService.getLicenceOldestYear());
                question.requirementLabel = question.requirementLabel.replace(/{{campaignstart}}/g, this.campaignService.getLicenceOldestYear());
                question.requirementLabel = question.requirementLabel.replace(/{{campaign}}/g, this.campaignService.getCurrentCampaignYear());
            });
            this.questions = questions;
            Object.keys(messages).forEach(messageKey => {
                messages[messageKey] = messages[messageKey].replace(/{{currentCampaign}}/g, this.campaignService.getCurrentCampaignYear());
                messages[messageKey] = messages[messageKey].replace(/{{nextCampaign}}/g, this.campaignService.getNextCampaignYear());
                messages[messageKey] = messages[messageKey].replace(/{{currentOrNextOpenCampaign}}/g, this.campaignService.getNextOpenCampaignYear());
            });
            this.messages = messages;
        });

        this.utilsService.setBckgrnd();
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    login (formValid: boolean) {
        if (formValid) {
            this.loginService.login({
                email: this.email,
                password: this.password,
                rememberMe: this.rememberMe
            }).then(() => {
                this.authenticationError = false;
                if (this.router.url === '/register' || (/activate/.test(this.router.url)) ||
                    this.router.url === '/finishReset' || this.router.url === '/requestReset') {
                    this.router.navigate(['']);
                }

                this.eventManager.broadcast({
                    name: 'authenticationSuccess',
                    content: 'Sending Authentication Success'
                });

                // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // // since login is succesful, go to stored previousState and clear previousState
                let previousState = this.stateStorageService.getPreviousState();
                if (previousState) {
                    this.stateStorageService.resetPreviousState();
                    this.router.navigate([previousState.name], { queryParams:  previousState.params });
                }
                this.router.navigate(['/ma-saisine']);
            }).catch(() => {
                this.authenticationError = true;
            });
        }
    }

    register () {
        this.router.navigate(['/register']);
    }

    requestResetPassword () {
        this.router.navigate(['/reset', 'request']);
    }

    checkQuestions() {
        return this.questions.length > 0 && this.questions.every(q => q.value);
    }

    messageContactUs() {
        return this.messages['homeContactUs'].replace(/{{contactEmail}}/g, this.regions.find( _ => _.academicRegionLabel === this.selectedRegionLabel).contactEmail);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.component.ts